import Vue from 'vue'
import App from './App.vue'
var numeral = require("numeral");
numeral.register('locale', 'pl', {
    delimiters: {
        thousands: ' ',
        decimal: ','
    },
    abbreviations: {
        thousand: 'k',
        million: 'm',
        billion: 'b',
        trillion: 't'
    },
    ordinal : function (number) {
        return number === 1 ? '' : '';
    },
    currency: {
        symbol: 'zł'
    }
})
numeral.locale('pl');  
Vue.filter("price", function (value) {
    return numeral(value).format("0,0.00"); // displaying other groupings/separators is possible, look at the docs
}); 
let target = document.getElementById('configurator');

if (target) {
    new Vue({
      el: '#configurator',
      render(h) { return h(App, {
        props: { 
            source: target.getAttribute('data-source') || {},
            admin: target.getAttribute('data-admin') == 'true',
            customer: parseInt(target.getAttribute('data-customer') || 0),
            configName: target.getAttribute('data-config')
          }
        }) }
    })

}
